const types = {
  SHOW_GLOBAL_LOADING: 'SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'HIDE_GLOBAL_LOADING',
  SET_SNACKBAR: 'SET_SNACKBAR',
  SHOW_SNACKBAR: 'SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'HIDE_SNACKBAR',
  SET_ENFATIZAR_SNACKBAR: 'SET_ENFATIZAR_SNACKBAR',
  SHOW_CONFIRMATION_DIALOG: 'SHOW_CONFIRMATION_DIALOG',
  HIDE_CONFIRMATION_DIALOG: 'HIDE_CONFIRMATION_DIALOG',
  SHOW_CONFIRMAR_DIALOG: 'SHOW_CONFIRMAR_DIALOG',
  HIDE_CONFIRMAR_DIALOG: 'HIDE_CONFIRMAR_DIALOG',
  SET_CONFIRMAR_DIALOG_PROMISE_RESOLVE: 'SET_CONFIRMAR_DIALOG_PROMISE_RESOLVE',
  SET_CONFIRMAR_DIALOG_PROMISE_REJECT: 'SET_CONFIRMAR_DIALOG_PROMISE_REJECT',
  SET_INFORMACAO: 'SET_INFORMACAO'
}

export default types
